import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { handleUpdateBandData } from "../BandEditPage"
import { Band } from "../../types/bands"

interface DrinkOptionsProps {
  band: Band
}

interface SelectOption {
  value: string | null
  label: string
}

interface ApiResponse {
  success: boolean
  errors?: {
    error: string
  }
}

export const DrinkOptions: React.FC<DrinkOptionsProps> = ({ band }) => {
  const customOnSubmit = async (
    data: Record<string, any>,
  ): Promise<ApiResponse> => {
    // data will be { additional_info: { drink_options: value } } from EditBandFormField
    return (await handleUpdateBandData(band.id, {
      additional_info: { drink_options: data.additional_info?.drink_options || null },
    })) as ApiResponse
  }

  const options: SelectOption[] = [
    { value: null, label: "Select drink options..." },
    { value: "full_bar", label: "Full Bar" },
    { value: "small_bar", label: "Small Bar" },
    { value: "byo", label: "BYO" },
    { value: "dry", label: "Dry" },
  ]

  const fieldData = {
    field: "additional_info.drink_options",
    name: "drinkOptions",
    label: "Drink Options",
    placeholder: "Select drink options",
    required: false,
  }

  return (
    <EditBandFormField
      type="select"
      fieldData={fieldData}
      bandId={band.id}
      options={options}
      onSubmit={customOnSubmit}
    />
  )
}

